import moment from 'moment';
import axios from 'axios';

// Helper for loading images and returning structured state
export function fetchS3Photos({ recordId, type, existingState = {}, source, process }) {
    return new Promise((resolve, reject) => {
        const payload = {
            process: process,
            RecordId: recordId,
            ObjectType: type
        };

        axios.post(
            '/postAWS',
            payload,
            {
                cancelToken: source.token
            })
            .then((res) => {
                const newState = {};
                const arrayStateMap = {};

                if(process === 'getRepUploads' && type !== 'portal'){
                    resolve(res.data);
                } else {
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(res.data.xml, "text/xml");
                    const contents = xmlDoc.getElementsByTagName("Contents");
                    const keys = [];

                    for (let i = 0; i < contents.length; i++) {
                        const keyTag = contents[i].getElementsByTagName("Key")[0];
                        if (keyTag) {
                            keys.push(keyTag.textContent);
                        }
                    }

                    if (!keys || keys.length === 0) return resolve({});

                    keys.forEach(doc => {
                        const parts = doc.split('/');
                        const fileName = parts[parts.length - 1];
                        const stateName = fileName.split('.')[0];

                        newState[stateName] = `https://v3-portal-file-storage.s3.us-west-2.amazonaws.com/${doc}`;

                        if(process !== 'getRepUploads'){
                            if (stateName.includes('-')) {
                                const base = stateName.split('-')[0];
                                const arrayKey = `${base}Array`;
                            if (!arrayStateMap[arrayKey]) arrayStateMap[arrayKey] = [];
                                arrayStateMap[arrayKey].push(stateName);
                            }
                        }
                    });

                    // Merge array keys
                    Object.keys(arrayStateMap).forEach(key => {
                        newState[key] = [
                            ...(existingState[key] || []),
                            ...arrayStateMap[key]
                        ];
                    });

                    resolve(newState);
                }
            })
            .catch(err => {
                console.log('POST Error Docs:\n', err);
                return reject(err);
            });
    });
}

export async function uploadSinglePhoto({file,stateName,stateNameError,username,opportunityId,type,setState,source}) {
    const sfDT = moment().format('YYYY-MM-DDTHH:mm:ss');
    const originalFileNameParts = file.name.split('.');
    const extension = originalFileNameParts.pop();
    const renamedFile = new File([file], `${stateName}.${extension}`, { type: file.type });
    const previewUrl = URL.createObjectURL(file);

    setState(prev => ({
        ...prev,
        uploading: true,
        filesToUpload: [...(prev.filesToUpload || []), renamedFile],
        [stateName]: `https://v3-portal-file-storage.s3.us-west-2.amazonaws.com/photo-pack/${opportunityId}/${type}/${renamedFile.name}`,
        errorMessage: ''
    }));

    const payload = {
        method: 'PUT',
        process: 'getUrl',
        bucket: 'v3-portal-file-storage',
        key: `photo-pack/${opportunityId}/${type}/${renamedFile.name}`,
        expiresSec: 60,
        RecordId: opportunityId,
        contentType: file.type,
        username,
        sfDT
    };

    try {
        // Get presigned URL
        const res = await axios.post('/postAWS', payload, { cancelToken: source?.token });
        const url = res?.data?.key;
        if (!url) {
            throw new Error('Missing presigned URL from server.');
        }

        // Upload file to S3
        const uploadRes = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': file.type,
                'Cache-Control': 'public, max-age=3600, must-revalidate',
                'x-amz-acl': 'public-read',
                'x-amz-meta-uploadedby': username,
                'x-amz-meta-uploadeddatetime': sfDT
            },
            body: file
        });

        if (uploadRes.status !== 200) {
            setState({ errorMessage: `${uploadRes.status} ${uploadRes.statusText}`, [stateNameError]: true });
            throw new Error(`${uploadRes.status} ${uploadRes.statusText}`);
        }

        setState(prev => ({
            ...prev,
            [stateNameError]: false,
            errorMessage: ''
        }));

        return { stateName, previewUrl };
    } catch (err) {
        console.error('Upload error:', err?.message || err);
        setState(prev => ({
            ...prev,
            [stateNameError]: true,
            errorMessage: err?.message || 'Upload failed.'
        }));
        throw err;
    } finally {
        setState(prev => ({ ...prev, uploading: false }));
    }
}

export function repUpload({
        file,
        fileName,
        username,
        opportunityId,
        source
    }) {
        return new Promise((resolve, reject) => {
            const sfDT = moment().format('YYYY-MM-DDTHH:mm:ss');
            const payload = {
                method: 'PUT',
                process: 'getUrl',
                bucket: 'v3-portal-file-storage',
                key: `repUploads/${opportunityId}/${fileName}`,
                expiresSec: 60,
                RecordId: opportunityId,
                contentType: file.type,
                username: username,
                sfDT: sfDT
            };
    
            axios.post(
                '/postAWS',
                payload,
                {
                    cancelToken: source.token
                })
                .then((res) => {
                    const url = res.data.key;
                    console.log(url);
                
                    const uploadRes = fetch(url, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': file.type,
                            'Cache-Control': 'public, max-age=3600, must-revalidate',
                            'x-amz-acl': 'public-read',
                            'x-amz-meta-uploadedby': username,
                            'x-amz-meta-uploadeddatetime': sfDT
                        },
                        body: file,
                    });
    
                    console.log('S3 Rep Upload success:', uploadRes);
                    resolve({ fileName });
                })
                .catch(err => {
                    console.error('POST Error Rep Upload URL:\n', err.message);
                    reject(err);
                });
    });
}